var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMypage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_262_230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.5C5.59476 0.5 0 6.09476 0 13C0 19.9052 5.59476 25.5 12.5 25.5C19.4052 25.5 25 19.9052 25 13C25 6.09476 19.4052 0.5 12.5 0.5ZM12.5 5.33871C14.9496 5.33871 16.9355 7.3246 16.9355 9.77419C16.9355 12.2238 14.9496 14.2097 12.5 14.2097C10.0504 14.2097 8.06452 12.2238 8.06452 9.77419C8.06452 7.3246 10.0504 5.33871 12.5 5.33871ZM12.5 22.6774C9.54133 22.6774 6.89012 21.3367 5.11593 19.2399C6.06351 17.4556 7.91835 16.2258 10.0806 16.2258C10.2016 16.2258 10.3226 16.246 10.4385 16.2812C11.0938 16.4929 11.7792 16.629 12.5 16.629C13.2208 16.629 13.9113 16.4929 14.5615 16.2812C14.6774 16.246 14.7984 16.2258 14.9194 16.2258C17.0817 16.2258 18.9365 17.4556 19.8841 19.2399C18.1099 21.3367 15.4587 22.6774 12.5 22.6774Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_262_230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25.8065,
    fill: "white",
    transform: "translate(0 0.0968018)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMypage);
export default __webpack_public_path__ + "static/media/icon_mypage.984ca8b6a608d3c2b83022e69baf846f.svg";
export { ForwardRef as ReactComponent };